const DEFAULT_CURRENCY = "COP";

export const normalizePlanCurrency = (currency) => {
  const code = String(currency || DEFAULT_CURRENCY).trim().toUpperCase();
  return /^[A-Z]{3}$/.test(code) ? code : DEFAULT_CURRENCY;
};

export const formatPlanAmount = (amount, currency) => {
  const code = normalizePlanCurrency(currency);
  const numericAmount = Number(amount) || 0;
  let symbol = "$";

  try {
    symbol = new Intl.NumberFormat("en", {
      style: "currency",
      currency: code,
      currencyDisplay: "narrowSymbol",
    }).formatToParts(0).find((part) => part.type === "currency")?.value || symbol;
  } catch (_error) {
    // The normalized fallback above keeps the UI readable if Intl does not
    // recognize a currency in an older browser.
  }

  const formattedAmount = numericAmount.toLocaleString("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return `${symbol}${formattedAmount}`;
};

export const formatPlanPrice = (amount, currency) =>
  `${formatPlanAmount(amount, currency)} ${normalizePlanCurrency(currency)}`;

export const planPeriodLabel = (billingPeriod) => {
  if (billingPeriod === "yearly") return "año";
  if (billingPeriod === "quarterly") return "trimestre";
  return "mes";
};
